'use client';
import { createContext } from 'react';
const outlineContext = createContext(null);
export default outlineContext;
